import React from "react";
import { useLocation } from "react-router-dom";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import { useTranslation } from "react-i18next";

const ViewAllRecommendation = () => {
  const location = useLocation();
  const { type, data } = location.state || {};
const { t } = useTranslation();
  return (
    <div className="view-all-container">
      <h2>
        {type === "people" && "People Recommendation"}
        {type === "job" && "Job Recommendation"}
        {type === "company" && "Company Recommendation"}
      </h2>

      <div className="view-all-list">
        <div className="container-fluid">
          <div className="row row-gap-3">
            {data?.map((item) => (
              <div
                className="col-lg-3"
                key={item.userUid || item.jobId || item.companyUid}
              >
                <div className="recommendation-card">
                  {/* Profile Picture / Company Logo */}
                  <img
                    src={item.profilPic || item.compLogo || item.companyLogo}
                    alt={item.fullName || item.compName || item.companyName}
                    className="avatar"
                  />

                  <div className="info">
                    <h5>
                      {item.fullName || item.compName || item.companyName}
                    </h5>
                    <p className="infofirstpara">
                      {item.nameTag || item.cityName || item.city}
                    </p>
                    <p className="infoSecondpara">{item.title}</p>
                    <p className="infoThirdpara">
                      {item.headLine || item.shortDescription}
                    </p>
                    <p className="infoForthparaFollower">
                      {item.followersCount || item.jobAppliedCount}{" "}
                      {type === "job" ? "Applicants" : "Followers"}
                    </p>
                    {item.mutualUsers?.count > 0 && (
                      <div className="pr-mutual Topmargin">
                        <p>{item.mutualUsers.text}</p>
                        <div className="mutual-imgs">
                          {item.mutualUsers.pics.map((pic, idx) => (
                            <img key={idx} src={pic} alt="Mutual Connection" />
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ✅ Job Applicants Info (if available) */}
                    {type === "job" && item.applicantsInfo?.count > 0 && (
                      <div className="pr-mutual Topmargin">
                        <p>{item.applicantsInfo.text}</p>
                        <div className="mutual-imgs">
                          {item.applicantsInfo.pics.map((pic, idx) => (
                            <img
                              key={idx}
                              src={pic}
                              alt={`Applicant ${idx + 1}`}
                            />
                          ))}
                        </div>
                      </div>
                    )}

                    {item.networkFollowers?.count > 0 && (
                      <div className="pr-mutual Topmargin">
                        <p>{item.networkFollowers.text}</p>
                        <div className="mutual-imgs">
                          {item.networkFollowers.pics.map((pic, idx) => (
                            <img
                              key={idx}
                              src={pic}
                              alt={`Connection ${idx + 1}`}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Actions Section */}
                  <div className="d-flex justify-content-between align-items-center postAction ChangePosition">
                    {type === "job" && (
                      <>
                        <BookmarkBorderSharpIcon className="material-symbols-sharp pointer" />
                      </>
                    )}
                  </div>

                  {type === "people" && (
                    <>
                      <div className="actions">
                        <button className="NewsnewRecommendationViewallbtn">
                          Connect
                        </button>
                        <button className="NewsnewRecommendationViewallbtn">
                          Follow
                        </button>
                      </div>
                    </>
                  )}

                  {type === "job" && (
                    <>
                      <div className="actions">
                        <button className="NewsnewRecommendationViewallbtn">
                          {t("SearchJob.Apply Now")}
                        </button>
                      </div>
                    </>
                  )}

                  {type === "company" && (
                    <div className="actions">
                      <button className="NewsnewRecommendationViewallbtn">
                        Follow
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllRecommendation;
